import { DataBean } from "../DataBean";


export class ExportProductionOrders extends DataBean {


    public async exportProductionOrders(idProductionOrder:any,productionOrderDate:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_exportProductionOrders_Number_java.util.Date", [idProductionOrder,productionOrderDate]);
    }

    public async exportProductionOrdersvdos(productionOrderDate:any,state:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_exportProductionOrders_java.util.Date_Number", [productionOrderDate,state]);
    }

  
}